<template>
    <div style="display: contents">
		<v-menu
			v-model="showNews"
			v-if="news.length > 0"
			transition="slide-y-transition"
			min-width="350"
			max-width="350"
            content-class="round-card"
			offset-y
			nudge-left="200">
			<template v-slot:activator="{ on }">
				<v-btn icon v-on="on" class="pulse-btn">
					<v-badge right overlap color="success" :content="news.length" :value="news.length > 0" class="pulse-badge">
						<v-icon :class="$eventBusUtility.iconAppBarColor">mdi-newspaper-variant-outline</v-icon>
					</v-badge>
				</v-btn>
			</template>

            <v-list two-line class="pa-0 notifications-list background-2" style="max-height: 400px; overflow-y: auto;">
				<v-subheader class="pt-2 fs12i" style="height:38px">Novità e Comunicazioni</v-subheader>

				<div v-for="(release, n) in news" :key="n" style="display: contents">
					<v-list-item
						style="height:62px"
						ripple
						@click.stop="openNew(release)">
						<v-list-item-avatar>
							<v-avatar size="34px" class="primary">
								<v-icon class="fs18i" color="white">mdi-new-box</v-icon>
							</v-avatar>
						</v-list-item-avatar>
						<v-list-item-content class="py-2 pl-0 pr-2">
							<v-list-item-title class="fs11i fw500">{{ release.title }}</v-list-item-title>
							<v-list-item-subtitle class="fs11i text-truncate">{{ stripHtml(release.description) }}</v-list-item-subtitle>
						</v-list-item-content>
					</v-list-item>
					<v-divider inset></v-divider>
				</div>

				<v-list-item v-if="news.length == 0">
					<v-list-item-content>
						<v-list-item-title class="fs11i fw500 text-center">Non ci sono novità</v-list-item-title>
					</v-list-item-content>
				</v-list-item>

				<v-list-item style="height:50px">
					<v-list-item-content>
						<v-btn text small ripple @click="goToHistory" color="primary" class="fs11i" style="margin:auto">Vedi tutte le novità</v-btn>
					</v-list-item-content>
				</v-list-item>
			</v-list>
		</v-menu>

		<v-dialog v-model="openNewsDialog" width="900px">
			<v-card class="background-2 round-card">
				<v-card-title class="subtitle-1 background-2">
					<v-icon left color="primary">mdi-new-box</v-icon>
					{{ currentNew.title }}
				</v-card-title>
				<v-divider></v-divider>
				<v-card-text class="pt-4">
					<blockquote class="blockquote" v-html="currentNew.description"></blockquote>
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn color="primary" text @click="openNewsDialog = false">Chiudi</v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>

export default {
	name: 'releases-menu',
	data() {
		return {
			openNewsDialog: false,
			showNews: false,
			news: [],
			currentNew: { title: '', description: '', expiration_date: '' }
		}
	},

	created() {
		this.axios.get('releases').then(response => {
			this.news = response.data.data.releases
		}).catch(() => {
			// error callback
		})
	},

	methods: {
		openNew(release) {
			this.openNewsDialog = true
			this.currentNew = release
		},

		goToHistory() {
			this.showNews = false
			this.$router.push('/releases-history')
		},

		formatDate(date) {
			if (!date) return ''
			const d = new Date(date)
			return d.toLocaleDateString('it-IT', {
				day: '2-digit',
				month: '2-digit',
				year: 'numeric'
			})
		},

		stripHtml(html) {
			if (!html) return ''
			const tmp = document.createElement('div')
			tmp.innerHTML = html
			return tmp.textContent || tmp.innerText || ''
		}
	}
}
</script>

<style scoped>
@keyframes pulse {
	0% {
		transform: scale(1);
		opacity: 1;
	}
	50% {
		transform: scale(1.35);
		opacity: 0.8;
	}
	100% {
		transform: scale(1);
		opacity: 1;
	}
}

.pulse-btn .pulse-badge >>> .v-badge__badge {
	animation: pulse 1.2s ease-in-out infinite;
	font-weight: bold;
	box-shadow: 0 2px 12px rgba(117, 244, 54, 0.6);
}

.pulse-btn:hover .pulse-badge >>> .v-badge__badge {
	animation: none;
	transform: scale(1.2);
}
</style>